var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleArrowRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.28859 6.92264C8.89859 7.29704 8.89859 7.90184 9.28859 8.27624L13.1686 12.001L9.28859 15.7258C8.89859 16.1002 8.89859 16.705 9.28859 17.0794C9.67859 17.4538 10.3086 17.4538 10.6986 17.0794L15.2886 12.673C15.6786 12.2986 15.6786 11.6938 15.2886 11.3194L10.6986 6.91304C10.3186 6.54824 9.67859 6.54824 9.28859 6.92264Z",
    fill: "#2F3037"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2886 6.92264C16.8986 7.29704 16.8986 7.90184 17.2886 8.27624L21.1686 12.001L17.2886 15.7258C16.8986 16.1002 16.8986 16.705 17.2886 17.0794C17.6786 17.4538 18.3086 17.4538 18.6986 17.0794L23.2886 12.673C23.6786 12.2986 23.6786 11.6938 23.2886 11.3194L18.6986 6.91304C18.3186 6.54824 17.6786 6.54824 17.2886 6.92264Z",
    fill: "#2F3037"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrowRight);
export default __webpack_public_path__ + "static/media/doubleArrowRight.ee5236792a5c54ba8a6fd0d6bd568df3.svg";
export { ForwardRef as ReactComponent };